import { IdentityClient } from './IdentityClient';

const _default_1: IdentityClient = new IdentityClient();

export default _default_1;
